import { Action, ActionType } from "@redux/actionTypes/projectInitiationActionTypes";
import { Reducer } from "redux";

export interface IProjectInitiationState {
  businessUnitListByUserId: IBusinessUnitList[];
  regionListByBusinessUnit: IRegionList[];
  countryListByRegion: ICountryList[];
  allBusinessUnitList: IBusinessUnitList[];
  projectDetailsByPID: IProjectDetail[];
  isInitiatedBU: boolean;
  acceptedBusinessUnitList: IBusinessUnitList[];
}

export interface IBusinessUnitList {
  businessUnitId: number;
  businessUnitName: string;
  isActive: boolean;
  createdDate: string;
  regionIds: string[];
  masterBusinessRegionMappingIds: string[];
  latitude: string;
  longitude: string;
  encBusinessUnitId: number;
  isDomestic: boolean;
}

export interface IRegionList {
  regionId: number;
  regionName: string;
  isActive: boolean;
  createdBy: string;
  createdDate: string;
  modifyBy: string;
  modifyDate: string;
  masterBusinessUnitRegionMappings: string[];
  masterRegionCountryMappings: string[];
  masterUserRegionMappings: string[];
}

export interface ICountryList {
  countryId: number;
  countryName: string;
  isActive: boolean;
  createdBy: string;
  createdDate: string;
  modifyBy: string;
  modifyDate: string;
  countryCode: string;
  isdcountryCode: boolean;
  masterCurrencyCountryMappings: string[];
  masterRegionCountryMappings: string[];
  masterUserCountryMappings: string[];
}

export interface ICreateProjectInitiation {
  projectName: string;
  initiatingBusinessUnitId: number;
  projectType: string;
  vendorName: string;
  isExtendToOtherBusinessUnit: string;
  extendedBusinessUnits: string[];
  projectDetailsByBusinessUnits: ProjectDetails[];
}

export interface ProjectDetails {
  businessUnitId: number;
  countryId: number;
  regionId: number;
  refDrugBrand: string;
  refDrugBrandOwner: string;
  dosageForm: string;
  packStyle: string;
  strength: string;
  strengthUnit: string;
  packTradeDress: string;
  packSize: string;
}

export interface IProjectDetail extends ICreateProjectInitiation {
  projectId: number;
}

export interface IAllExtendedBULists {
  extendedBusinessUnits: extendedBU[];
  isSubmitEnabled: boolean;
}
export interface extendedBU {
  otherBusinessUnitId: number;
  projectId: number;
  businessUnitId: number;
  acceptanceStatus: string;
  projectName: string;
  businessUnit?: {
    businessUnitName: string;
  };
  isEditable?: boolean;
}
export interface IDeleteProjectPayload {
  projectId: number;
  projectDetailsByBusinessUnits: {
    detailId: number;
    projectId: number;
    strength: string;
  }[];
}
const initialState = {
  businessUnitListByUserId: [],
  regionListByBusinessUnit: [],
  countryListByRegion: [],
  allBusinessUnitList: [],
  projectDetailsByPID: [],
  allExtendedBULists: [],
  isInitiatedBU: false,
  acceptedBusinessUnitList: [],
};

export const projectInitiationReducer: Reducer<IProjectInitiationState, Action> = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.BUSINESS_UNIT_LIST_USER_ID:
      return {
        ...state,
        businessUnitListByUserId: action.payload,
      };
    case ActionType.REGION_LIST_BY_BUSINESS_UNIT:
      return {
        ...state,
        regionListByBusinessUnit: action.payload,
      };
    case ActionType.COUNTRY_LIST_BY_REGION:
      return {
        ...state,
        countryListByRegion: action.payload,
      };
    case ActionType.ALL_BUSINESS_UNIT_LIST:
      return {
        ...state,
        allBusinessUnitList: action.payload,
      };
    case ActionType.PROJECT_DETAILS_BY_PID:
      return {
        ...state,
        projectDetailsByPID: action.payload,
      };
    case ActionType.IS_INITIATED_BU:
      return {
        ...state,
        isInitiatedBU: action.payload,
      };
    case ActionType.ACCEPTED_BUSINESS_UNIT_LIST:
      return {
        ...state,
        acceptedBusinessUnitList: action.payload,
      };
    case ActionType.CLEAR_REGION_LIST: {
      return {
        ...state,
        regionListByBusinessUnit: [],
        countryListByRegion: [],
      };
    }
    case ActionType.CLEAR_BUSINESSUNIT_LIST_BY_UID: {
      return {
        ...state,
        businessUnitListByUserId: [],
      };
    }
    case ActionType.RESET_REDUX_STATE: {
      return initialState;
    }

    default:
      return state;
  }
};
